import { api } from './api'
import { downloadFile, generateFHIRFilename } from '../utils/fhirExportUtils'

/**
 * FHIR Export Service
 * Handles exporting patient records in FHIR R4 format
 */
export const fhirExportService = {
  /**
   * Export a patient record to FHIR format
   * @param patientId - The patient ID to export
   * @param maskPII - Whether to mask PII in the export
   * @returns Promise that resolves when download is triggered
   */
  exportPatientToFHIR: async (patientId: string, maskPII: boolean = false): Promise<void> => {
    try {
      // Call the API endpoint - api.get returns { data: T }
      const response = await api.get(`/patients/${patientId}/export/fhir`, {
        params: {
          maskPII: maskPII.toString(),
        },
      })

      // Get the FHIR Bundle from response.data
      const fhirBundle = response.data
      
      // Convert to formatted JSON string
      const formattedJson = JSON.stringify(fhirBundle, null, 2)
      
      // Generate filename
      const filename = generateFHIRFilename(patientId, maskPII)
      
      // Trigger download
      downloadFile(formattedJson, filename)
    } catch (error: any) {
      console.error('Error exporting patient to FHIR:', error)
      throw new Error(
        error.response?.data?.message || 
        error.message || 
        'Failed to export patient record'
      )
    }
  },
}




